import { useState } from 'react';
import { Location } from 'history';

export const createPromptForUnsavedChanges =
  (
    setNextLocation: (location: Location) => void,
    showChangesModal: (modalState: unknown) => void,
    modalId: string,
    changesConfirmed: boolean,
  ) =>
  (nextLoc: Location) => {
    setNextLocation(nextLoc);
    if (!changesConfirmed) {
      showChangesModal(modalId);
    }
    // Prevent navigation when unsaved changes
    return changesConfirmed;
  };

export const useUnsavedChangesPrompt = (
  showChangesModal: (modalState: unknown) => void,
  modalId: string,
) => {
  const [nextLocation, setNextLocation] = useState<Location | null>(null);
  const [changesConfirmed, setChangesConfirmed] = useState<boolean>(false);
  return {
    changesConfirmed,
    promptForUnsavedChanges: createPromptForUnsavedChanges(
      setNextLocation,
      showChangesModal,
      modalId,
      changesConfirmed,
    ),
    nextLocation,
    confirmChanges: () => {
      setChangesConfirmed(true);
    },
  };
};
